module.exports = __webpack_public_path__ + "img/home_city_icon1_disabled.9778e53.png";